// Homepage H1 copy. Swap `HEADLINE` between the variants to restore.
export const HEADLINE_STORIES = { line1: "An Event for a Day.", line2: "Stories for a Lifetime." };
export const HEADLINE_ORIGINAL = { line1: "Bring Your People Together.", line2: "We'll Bring the Fun." };
export const HEADLINE = HEADLINE_STORIES;
export const HERO_EYEBROW = "Live-Hosted Experiences ★ Custom Games ★ Leadership Development";
export const HERO_EYEBROW_ITEMS = ["Live-Hosted Experiences", "Custom Games", "Leadership Development"];
export const HERO_INTRO = {
  line1: "Fully produced, live-hosted experiences for corporate teams, country clubs, communities, charities and private celebrations.",
  line2: "We handle every detail, from concept to execution.",
};
